import {IFaqItem} from "./IFaqItem";
import {ISection} from "../../model/B2CInfo";
import '../../MainScreen.css'
import './FaqItem.css'
import FaqQuestion from "./FaqQuestion";
import MobileSectionHeader from "../../MobileSectionHeader";

interface IFaqItemProps {
    section: ISection
    mobile: boolean
}

export default function FaqItem(props: IFaqItemProps) {
    if (props.mobile) {
        let faqItems = (props.section.data as Array<IFaqItem>).map((item, index) => {
            let questions = item.questions.map((question) => <FaqQuestion mobile={true} question={question}/>)
            let style = {}
            if (index == 0) {
                style = {marginTop: "34px"}
            }
            return <div className="Faq_item_section_mobile" style={style}>
                <div className="Faq_item_section_mobile__title">{item.title}</div>
                {questions}
            </div>
        });
        return <div className="Faq_item_mobile">
            <MobileSectionHeader section={props.section}/>
            {faqItems}
        </div>
    } else {
        let faqItems = (props.section.data as Array<IFaqItem>).map((item) => {
            let questions = item.questions.map((question) => <FaqQuestion mobile={false} question={question}/>)
            return <div className="Faq_item_section">
                <div className="Faq_item_section_title">{item.title}</div>
                <div className="Faq_item_section_questions_container">
                    {questions}
                </div>
            </div>
        });
        return <div className="Section_container" style={{alignItems: "start"}}>
            <div style={{marginTop: "-72px"}} id={props.section.id}/>
            <div className="Faq_item_title">
                {props.section.title}
            </div>
            {faqItems}
        </div>
    }
}